export default {
  id: 'setting-up-profile',
  title: 'Setting Up Your Profile',
  content: `## Setting Up Your Profile

Before you place your first trade, complete your Risk Profile. It takes about 2 minutes and drives everything — your recommended position size, daily trade limit, discipline score, and AI coaching context.

---

## Where to Find It

**Profile → Risk Profile** (bottom nav → person icon → Risk Profile section)

---

## How It Works

The questionnaire has **13 questions** across three categories. There is no Save button — your answer is saved automatically the moment you tap an option. You can go back and change any answer at any time without retaking the full quiz.

| Category | Questions | Weight |
|---|---|---|
| Financial Capacity | 5 — age, income, allocation %, loans, dependents | 30% |
| Knowledge & Experience | 2 — trading experience, TA knowledge | 20% |
| Behavioral Traits | 6 — capital source, loss tolerance, SL discipline, trading goal | 50% |

---

## What You Get After Completing

Once all 13 questions are answered you see your **Risk Score** (0–100) and three recommendations:

| Output | What it means |
|---|---|
| Risk % per trade | Max % of your account you should lose on one trade |
| Trading style | Suggested style based on your profile and experience level |
| Max trades per day | How many trades your profile supports in a single session |

These are recommendations, not hard limits. You can trade beyond them — the platform will warn you and factor deviations into your Discipline Score.

---

## What to Complete Before Your First Trade

- [ ] **Risk Profile** — answer all 13 questions so the platform can coach you accurately
- [ ] **Learning module** — understand SL, Target, and R:R before placing orders
- [ ] **Position Size Calculator** — open it from the Risk Profile page and plan one trade

---

## Behavioral Snapshot

After you have made several trades and ACT sessions, TradeReflex AI builds a **behavioral snapshot** automatically from your activity. You do not need to complete a separate personality assessment. The summary updates as your recent behavior changes.
`,
};
